import { Link } from 'react-router-dom';
import { Flex, Box, Button } from 'components/ui';
import styled from 'styled-components';
import { Row, Col } from 'react-grid-system';
import { isDev, polygonScanBaseURL } from 'utils/config';
import { ReactNode } from 'react';

interface RemixSuccessProps {
  tokenId?: number;
  gasUsed?: number;
  transactionHash?: string;
  preview?: ReactNode;
  price: string;
  burnA: boolean;
  burnB: boolean;
  ownsMixpass: boolean;
  onClose: () => void;
}

const SLink = styled(Link)`
  color: white;
  text-decoration: underline;
`;

const RemixSuccess = ({
  tokenId,
  gasUsed,
  transactionHash,
  preview,
  price,
  burnA,
  burnB,
  ownsMixpass,
  onClose,
}: RemixSuccessProps) => {
  return (
    <Row>
      <Col>
        <Box p={4}>
          <Box mb={2} fontWeight="bold" fontSize="24px">
            Remix Created!
          </Box>
          <Box mb={4}>You have successfully minted a Futura Remix.</Box>

          <Flex alignCenter mb={4}>
            <Box fontWeight="bold" fontSize="24px" mr={3}>
              <SLink to={`/futura/details/${tokenId}`}>Remix #{tokenId}</SLink>
            </Box>
            <SLink to={`/my-collection`}>View in collection</SLink>
          </Flex>

          <Box mb={3}>(Might take a couple of minutes to show up in your collection)</Box>

          <Box my={3} width="320px">
            {preview}
          </Box>
        </Box>
      </Col>

      <Col>
        <Box p={4} backgroundColor="black" height="calc(100vh - 200px)">
          <Box fontSize="24px" mb={4}>
            Minting Details
          </Box>

          <Flex p={1} borderBottom="1px solid white" justifyBetween>
            <Box>Futura Remix</Box>
            <Box>0.005 Ξ</Box>
          </Flex>
          {burnA && (
            <Flex p={1} borderBottom="1px solid white" justifyBetween>
              <Box>Burn Input A Discount</Box>
              <Box>-0.0025 Ξ</Box>
            </Flex>
          )}
          {burnB && (
            <Flex p={1} borderBottom="1px solid white" justifyBetween>
              <Box>Burn Input B Discount</Box>
              <Box>-0.0025 Ξ</Box>
            </Flex>
          )}
          {ownsMixpass && !burnA && !burnB && (
            <Flex p={1} borderBottom="1px solid white" justifyBetween>
              <Box>Mixpass Discount</Box>
              <Box>-0.00125 Ξ</Box>
            </Flex>
          )}
          <Flex p={1} borderBottom="1px solid white" justifyBetween>
            <Box>Minting total</Box>
            <Box>{price} Ξ</Box>
          </Flex>

          {/* don't show gas used in production */}
          {isDev() && <Box p={1}>Gas used: {Number(gasUsed).toLocaleString()} gwei</Box>}

          <Box my={4}>
            <SLink
              to={{ pathname: `${polygonScanBaseURL}/${transactionHash}` }}
              rel="noopened noreferrer"
              target="_blank"
            >
              View on Polygonscan
            </SLink>
          </Box>

          <Button onClick={onClose}>Create another remix!</Button>
        </Box>
      </Col>
    </Row>
  );
};

export default RemixSuccess;
